<span class="{{iconPrefix}}-{{icon}} {{additionalClasses}}" aria-hidden="true"></span>